import React from "react";
import { AlertTriangle } from "lucide-react";
import "./FormError.css";

function FormError({ children, tone = "danger" }) {
    if (!children) return null;
    return (
        <div className={`form-error form-error--${tone}`} role="alert">
            <AlertTriangle size={14} aria-hidden="true" />
            <span>{children}</span>
        </div>
    );
}

export default FormError;
